import axios from '@/axios';
import LensOrderUrlManager from '../LensOrderUrlManager';

export default class FetchReviewRequest
{
    /** LensOrder Vue component. */
    v = null;

    /** @type {"right"|"left"} */
    side = null;

    constructor(v, side)
    {
        this.v = v;
        this.side = side;
    }

    async handle()
    {
        if(!this.v.isOrderEdition)
        {
            // Skip handler if not editing an existing order.
            return true;
        }

        /** @type {LensOrderUrlManager} */
        const um = this.v.lensOrderUrlManager;
        const reference = um.getOrderReference(this.side);
        if(reference === null)
        {
            return true;
        }

        const url = `/api/order/${reference}/review-request`;

        try
        {
            const { data: reviewRequest } = await axios.get(url);
            this.v.reviewRequest[this.side] = reviewRequest;
            return true;
        }
        catch(error)
        {
            const status = error?.response?.status ?? 500;
            if(status === 404)
            {
                console.log(`Review request not found for order ${reference}`);
                return true;
            }

            console.log(`Could not retrieve review request for order ${reference}`);
            throw error;
        }
    }
}
